var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMailIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3999 2.73486H2.5999C1.9399 2.73486 1.3999 3.27486 1.3999 3.93486V13.2649H14.5999V3.93486C14.5999 3.27486 14.0599 2.73486 13.3999 2.73486ZM11.7499 3.93486L7.9999 7.16486L4.2499 3.93486H11.7499ZM2.5999 12.0749V4.10486L7.9999 8.76486L13.3999 4.10486V12.0749H2.5999Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMailIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/mail_icon.6c186af5.svg";
export { ForwardRef as ReactComponent };